import { render, staticRenderFns } from "./select-multiple-product.vue?vue&type=template&id=92f93a80&scoped=true&"
import script from "./select-multiple-product.vue?vue&type=script&lang=js&"
export * from "./select-multiple-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f93a80",
  null
  
)

export default component.exports